export default {
  agents: 'Agents',
  manageAgentsTitle: 'Manage agents',
  manageAgentsDescription: 'Create custom agents for your tasks.',
  agentTemplatesTitle: 'Agent templates',
  agentTemplatesDescription:
    'Start with a ready-made setup, then adapt every field to your workflow.',
  agentTemplatesLoading: 'Loading agent templates',
  agentTemplatesLoadFailed: 'Unable to load agent templates.',
  noAgentTemplates: 'Agent templates are not available yet.',
  agentTemplateFallbackDescription: 'A ready-made agent template.',
  agentTemplateLoading: 'Loading agent template',
  agentTemplateLoadFailed: 'Unable to load this agent template.',
  useTemplate: 'Use template',
  agentTemplateCategoryFilter: 'Filter agent templates by category',
  agentTemplateCategoryAll: 'All',
  agentTemplateCategoryManagement: 'Management',
  agentTemplateCategoryDevelopment: 'Development',
  agentTemplateCategoryMarketing: 'Marketing',
  agentTemplateCategorySales: 'Sales',
  agentTemplateCategoryHr: 'HR',
  agentTemplateCategorySupport: 'Support',
  agentTemplateCategoryOther: 'Other',
  documentationAgentName: 'Documentation agent',
  documentationAgentDescription:
    'Analyzes completed work and prepares evidence-based documentation updates.',
  sprintPlannerName: 'Sprint planner',
  sprintPlannerDescription:
    'Builds a sprint plan from its goal, capacity, and the current backlog.',
  taskAnalystName: 'Task analyst',
  taskAnalystDescription:
    'Defines and estimates tasks against strategy, roadmap, and source code.',
  salesCoordinatorName: 'Sales Coordinator',
  salesCoordinatorDescription:
    'Prepares personalized customer emails from company strategy and data, then sends them after approval.',
  newAgent: 'New agent',
  editAgent: 'Edit agent',
  createAgent: 'Create agent',
  saveAgentChanges: 'Save changes',
  manageAgents: 'Manage',
  searchAgents: 'Search agents',
  noDescription: 'No description',
  toolsCount_one: '{{count}} tool',
  toolsCount_other: '{{count}} tools',
  edit: 'Edit',
  deleteAgent: 'Delete agent',
  deleteAgentTitle: 'Delete agent?',
  deleteAgentDescription:
    'Agent “{{name}}” will be permanently deleted and cannot be restored.',
  cancel: 'Cancel',
  retry: 'Retry',
  toolsLoadFailed: 'Unable to load the tools catalog.',
  agentsLoadFailed: 'Unable to load organization agents.',
  agentLoadFailed: 'Unable to load this agent.',
  agentNotFound: 'This agent was not found or has been deleted.',
  noAgents: 'This organization has no custom agents yet.',
  noAgentsMatching: 'No agents match your search.',
  name: 'Name',
  namePlaceholder: 'QA reviewer',
  description: 'Description',
  descriptionPlaceholder: 'Reviews tasks, PRs, and release notes',
  instructions: 'Instructions',
  instructionsDescription: 'Describe the agent purpose and behavior.',
  instructionsPlaceholder:
    'You are a release assistant. Check issue readiness in Jira, find related documents, and briefly report risks. Do not change data without user confirmation.',
  refineInstructions: 'Improve instructions',
  instructionRefinementFailed: 'Unable to improve the instructions. Try again.',
  tools: 'Tools',
  capabilities: 'Capabilities',
  toolsDescription: 'Choose the tools this agent can use.',
  triggers: 'Triggers',
  triggersDescription: 'Run the agent on a schedule or integration event.',
  addTrigger: 'Add trigger',
  triggerDraft: 'Will be created with the agent',
  deleteTriggerTitle: 'Delete trigger?',
  deleteTriggerDescription: '“{{name}}” will be deleted.',
  triggerCreatePartialFailed:
    'The agent was created, but some triggers were not saved.',
  defaultCapabilities: 'Default capabilities',
  workspaceIntegrations: 'Workspace integrations',
  docs: 'Documents',
  jira: 'Jira',
  confluence: 'Confluence',
  github: 'GitHub',
  gmail: 'Gmail',
  yandexMail: 'Yandex Mail',
  calendar: 'Calendar',
  requiresProvider: 'Requires {{provider}}',
  noConnectionRequired: 'No connection required',
  selectAll: 'Select all',
  clearAll: 'Clear all',
  toggleCategoryTools: 'Toggle tools in {{category}}',
  selectedToolsCount: '{{selected}} of {{total}} selected',
  noToolsRegistered: 'No tools are registered yet.',
  nameRequired: 'Enter an agent name.',
  nameInvalid: 'Name must contain 2–60 letters, numbers, spaces, or dashes.',
  nameAlreadyExists: 'An agent with this name already exists',
  instructionsRequired: 'Add instructions for this agent.',
  settings: 'Settings',
  settingsDescription: 'Set the agent name, description, and appearance.',
  generateName: 'Generate name',
  generateDescription: 'Generate description',
  metadataGenerationFailed: 'Unable to generate this value. Try again.',
  chooseAgentIcon: 'Choose agent icon',
  selectAgentIcon: 'Choose the {{icon}} icon',
  tags: 'Tags',
  addTag: 'Add tag',
  tagInput: 'New tag',
  tagPlaceholder: 'For example, Releases',
  removeTag: 'Remove {{tag}} tag',
  agentCreated: 'Agent created',
  agentUpdated: 'Agent updated',
  agentDeleted: 'Agent deleted',
  agentCreateFailed: 'Unable to create agent',
  agentUpdateFailed: 'Unable to update agent',
  agentDeleteFailed: 'Unable to delete agent',
  laplaceDefault: 'Laplace',
  selectAgent: 'Select agent',
  agentSelectorMentionConflict:
    'The selected agent does not match the @handle at the start of the message.',
  agentUnavailable: 'The selected agent is no longer available.',
  allAgents: 'All',
  createdByMe: 'Created by me',
  sortAgents: 'Sort agents',
  recentlyUpdated: 'Recently updated',
  sortByName: 'By name',
  agent: 'Agent',
  owner: 'Owner',
  updated: 'Updated',
  actions: 'Actions',
  agentActions: 'Actions for {{name}}',
  you: 'You',
}
